import { cva, VariantProps } from "class-variance-authority"

export { default as Skeleton } from "./Skeleton.vue"

const skeletonConfig = {
  variants: {
    variant: {
      square: "rounded-md",
      rounded: "rounded-full",
    },
    color: {
      light: "bg-skeleton-light",
      medium: "bg-skeleton-medium",
      primary: "bg-skeleton-primary",
    },
  },
}

export const skeletonVariants = cva("animate-pulse", skeletonConfig)

export type SkeletonVariants = VariantProps<typeof skeletonVariants>

export const skeletonVariantKeys = Object.keys(
  skeletonConfig.variants.variant,
) as Array<keyof typeof skeletonConfig.variants.variant>

export const skeletonColorKeys = Object.keys(
  skeletonConfig.variants.color,
) as Array<keyof typeof skeletonConfig.variants.color>
